<template>
    <div>
        <div id="mainhold">
            <div id="leftleaf" v-if="addingMuseums">
                <div class="section">
                    <input class="textbox" type="text" placeholder="Museum Name" v-model="aMuseumName">
                    <input class="textbox" type="text" placeholder="Street" v-model="aMuseumStreet">
                    <input class="textbox" type="text" placeholder="City" v-model="aMuseumCity">
                    <input class="textbox" type="text" placeholder="State / Region" v-model="aMuseumRegion">
                    <input class="textbox" type="text" placeholder="Country" v-model="aMuseumCountry">
                    <input class="textbox" type="text" placeholder="Website" v-model="aMuseumWebsite">
                    <input class="textbox" type="text" placeholder="Phone" v-model="aMuseumPhone">
                    <input class="textbox" type="file" ref="museumRef">
                    <div class="btn2 bgMint cpointer" @click="uploadMBG">Upload Image</div>
                    <div class="btn2 bgPink cpointer" @click="saveMuseum">SAVE MUSEUM</div>
                </div>
            </div>
            <div id="leftcolumn" class="cols">
                <div class="section">
                <div class="lineWrapper" @click="addMuseums">Museums +
                </div>
                <div v-for="(museum, index) in museums" :key="index">
                    <div class="option" @click="populateInfo(museum)">{{museum.museum}}</div>
                </div>
                </div>
                <div class="section">
                <div class="lineWrapper">Museum Exhibitions</div>
                <div v-for="(exhibit, index) in exhibits" :key="index">
                    <div class="exhibitList" @click="showDetail(exhibit)">
                        <div class="lineWrapper amTealregular">{{exhibit.eventHost}}</div>
                        <div class="lineWrapper amGrayregular">{{exhibit.eventTitle}}</div>
                    </div>
                </div>
                </div>
            </div>
            <div id="rightcolumn" class="cols">
                <input type="text" class="textbox" placeholder="Museum" v-model="museumName">
                <input type="text" class="textbox" placeholder="Title" v-model="exTitle">
                <datepicker name="startDate" v-model="dateSelect.date"></datepicker>
                <datepicker name="endDate" v-model="dateSelect2.date"></datepicker>
                <div class="section" v-if="isExisting">
                    <div class="lineWrapper">{{displayStart}} - {{displayEnd}}</div> 
                </div>
                <input type="text" class="textbox" placeholder="Link" v-model="infoLink">
                
                <div class="spacer"></div>
                <textarea class="textview" v-model="exDesc"></textarea>
                <div class="spacer"></div>
                <select class="textbox" v-model="live">
                <option value="null">LIVE STAT</option>
                <option value='true'>TRUE</option>
                <option value='false'>FALSE</option>
                </select>
                <div class="holder amTealregular textleft" v-if="!isUploaded">Add Event Image<br>
                    <div class="amGrayregular text">IMG<input type="file" ref="fileInput"></div>
                    <div class="spacer"></div>
                    <div class="section">
                    <div class="btn2 bgPink cpointer textcenter" @click="uploadPics()">Upload</div>
                    <div class="lineWrapper" v-if="isExisting">Current Image {{fsimg}}</div>
                    </div>
                </div>
                <div class="section">
                <div class="btn2 bgTeal cpointer" @click="uploadEvent">SAVE EXHIBITION</div>
                </div>
                <div class="section">
                <div class="btn2 bgMint cpointer" @click="clearAll">Clear</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app';
import Datepicker from 'vuejs-datepicker';
import moment from 'moment';
import { resizeImage } from "../utils";
import 'firebase/functions'
import 'firebase/auth'
import 'firebase/firestore'
import db from '../main'
// import _ from 'lodash'
export default {
    name:"museums",
    data(){
        return {
            exhibits: [],
            exhibit: {},
            museumName: "",
            exTitle: "",
            exDesc: "",
            startDate: "",
            endDate: "",
            fsimg: "",
            imgBlob: "",
            dateSelect: new Date(),
            dateSelect2: new Date(),
            visible: false,
            isUploaded: false,
            city: "",
            state: "",
            country: "",
            uploadValue: "",
            infoLink: "",
            isExisting:false,
            displayStart: "",
            displayEnd: "",
            live: false,
            addingMuseums: false,
            museums: [],
            aMuseumName: "",
            aMuseumCity: "",
            aMuseumRegion: "",
            aMuseumCountry: "",
            aMuseumStreet: "",
            aMuseumPhone: "",
            aMuseumWebsite: "",
            aMuseumBG:"",
            aMuseumBlob: "",
            // museums: [
            //     {"museumName": "SFMOMA", "city":"San Francisco", "state":"CA", "country":"US"},
            //     {"museumName": "de Young", "city":"San Francisco", "state":"CA", "country":"US"},
            //     {"museumName": "Legion of Honor", "city":"San Francisco", "state":"CA", "country":"US"},
            //     {"museumName": "Contemporary Jewish Museum", "city":"San Francisco", "state":"CA", "country":"US"},
            //     {"museumName": "LACMA", "city":"Los Angeles", "state":"CA", "country":"US"},
            //     {"museumName": "The Broad", "city":"Los Angeles", "state":"CA", "country":"US"},
            //     {"museumName": "The Met", "city":"New York", "state":"NY", "country":"US"},
            //     {"museumName": "Guggenheim Museum", "city":"New York", "state":"NY", "country":"US"},
            // ]
        }
    },
    created(){
        this.fetchEvents()
        this.fetchMuseums()
    },
    methods: {
        fetchMuseums(){
            this.museums = []
            db.collection('artmuseo').doc('museums').collection('museums').orderBy('museum').get().then(museums => {
                if(museums){
                    museums.forEach(muse => {
                        const data = muse.data();
                        this.museums.push(data);
                    })
                }
            })
        },
        fetchEvents(){
            this.exhibits = []
            db.collection("events_post").where('eventType', '==', "exhibits").get().then(docs => {
            if(docs){
                docs.forEach(doc => {
                    const data = doc.data();
                    this.exhibits.push(data)
                })
            }
        })
        },
        addMuseums(){
            if(this.addingMuseums){
                this.addingMuseums = false
            } else {
                this.addingMuseums = true
            }
        },
        uploadMBG(){
            const input = this.$refs.museumRef;
            const files = input.files;
            if(files && files[0]){
                resizeImage({
                    file:files[0],
                    sizes:[300]
                }).then(({blobs}) => {
                    this.aMuseumBlob = blobs[0]
                    const fileref = "bg_" + this.aMuseumName + this.aMuseumCity + ".png"
                    if(this.imgBlob !== undefined){
                        const storageRef = firebase.storage().ref().child('museums').child(fileref).put(this.aMuseumBlob);
                        storageRef.on('state_changed', snapshot => {
                            this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        }, error => {
                            alert(error.message);
                        }, () => {
                            this.uploadValue = 100;
                            storageRef.snapshot.ref.getDownloadURL().then(imgurl => {
                                this.aMuseumBG = imgurl
                                this.aMuseumBlob = null
                                alert('Upload Successful')
                                console.log("UPLOADED MUSEUM WITH THIS LINK, ", imgurl)
                            })
                        })
                    }
                })
            }
        },
        saveMuseum(){
            const uploadMuseum = db.collection('artmuseo').doc('museums').collection('museums').doc()

            const data = {
                bg: this.aMuseumBG,
                city: this.aMuseumCity,
                region: this.aMuseumRegion,
                country: this.aMuseumCountry,
                street: this.aMuseumStreet,
                phone: this.aMuseumPhone,
                museum: this.aMuseumName,
                link: this.aMuseumWebsite,
                id: uploadMuseum.id
            }

            if (data.bg !== ""){
                uploadMuseum.set(data, {merge:true}).then(() => this.successMUpdate())
            } else {
                alert('No empty fields')
            }
        },
        successMUpdate(){
            alert('Uploaded Museum Entry')
            this.addingMuseums = false
            this.fetchMuseums()
        },
        populateInfo(museum){
            const city = museum.city
            const state = museum.region
            const country = museum.country
            const museumName = museum.museum
            this.city = city
            this.state = state
            this.country = country
            this.museumName = museumName
        },
        uploadEvent(){
            const startdate = moment(this.dateSelect.date).format('LL')
            const enddate = moment(this.dateSelect2.date).format('LL')
            const startInt = moment(this.dateSelect.date).unix()
            const endInt = moment(this.dateSelect2.date).unix()
            const exTitle = this.exTitle
            const museumName = this.museumName
            const exDesc = this.exDesc
            const visible = Boolean(this.live)
            const city = this.city
            const state = this.state
            const country = this.country
            const fileURL = this.fsimg
            const eLink = this.infoLink
            console.log(fileURL, startdate, enddate, startInt, endInt, exTitle, museumName, exDesc, visible, city, state, country)
            
            const edoc = db.collection('events_post').doc()

            const data = {
                eventCity: city,
                eventCountry: country,
                eventDate: startdate,
                eventEnd: enddate,
                eventDetails: exDesc,
                eventHost: museumName,
                eventAddress: museumName,
                eventID:edoc.id,
                eventIMG: fileURL,
                eventState: state,
                eventTitle: exTitle,
                eventType: "exhibits",
                info_link: eLink,
                rsvp: false,
                orderby: startInt,
                endInt: endInt,
                metaIMG: this.fsimg,
                visible:visible,
            }
            edoc.set(data,{merge:true}).then(() => {
                this.fetchEvents()
                this.clearAll()
            })
        },
        showDetail(exhibit){
            this.isExisting = true
            this.exTitle = exhibit.eventTitle
            this.exDesc = exhibit.eventDetails
            this.city = exhibit.eventCity
            this.state = exhibit.eventState 
            this.country = exhibit.eventCountry
            this.museumName = exhibit.eventHost
            this.live = exhibit.visible
            this.fsimg = exhibit.eventIMG
            this.infoLink = exhibit.info_link
            this.displayStart = exhibit.eventDate
            this.displayEnd = exhibit.eventEnd
        },
        clearAll(){
            this.exTitle = ""
            this.exDesc = ""
            this.city = ""
            this.state = ""
            this.country = ""
            this.museumName = ""
            this.visible = false
            this.fsimg = ""
            this.imgBlob = null
            this.infoLink = ""
            this.isExisting = false
        },
        uploadPics(){
            const input = this.$refs.fileInput;
            const files = input.files;
            if(files && files[0]){
                resizeImage({
                    file:files[0],
                    sizes:[600]
                }).then(({blobs}) => {
                    this.imgBlob = blobs[0]
                    const fileref = "ex_" + this.museumName + this.exTitle + ".png"
                    if(this.imgBlob !== undefined){
                        const storageRef = firebase.storage().ref().child('eventBanners').child(fileref).put(this.imgBlob);
                        storageRef.on('state_changed', snapshot => {
                            this.uploadValue = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                        }, error => {
                            alert(error.message);
                        }, () => {
                            this.uploadValue = 100;
                            storageRef.snapshot.ref.getDownloadURL().then(imgurl => {
                                this.fsimg = imgurl
                                this.imgBlob = null
                                console.log("UPLOADED WITH THIS LINK, ", imgurl)
                            })
                        })
                    }
                })
            }
        }
    },
    components: {
        'datepicker': Datepicker,
    }
}
</script>

<style scoped>
#mainhold {
    width: 100%;
    height: 85vh;
    background-color: white;
    position: relative;
    overflow: scroll;
    margin-top: 50px;
}

.option {
    width: auto;
    height: auto;
    float: left;
    clear: right;
    padding: 1%;
    margin-right:5px;
    margin-bottom: 5px;
    cursor: pointer;
    color: white;
    background-color: teal;
}

.cols {
    width: 50%;
    height: auto;
    float: left;
    clear: right;
    padding: 5%;
    border-right-color: #00a89d;
    border-right-width: 2px;
}

.wrap {
    width: 100%;
    height: auto;
    margin-top: 2%;
    margin-bottom: 2%;
}

#leftleaf {
    width: 50vw;
    height: 100vh;
    background-color: #00a89d;
    padding: 5%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
}

.exhibitList {
    width: 100%;
    height: auto;
    padding: 3%;
    background-color: aliceblue;
    border-radius: 1vmin;
    margin-bottom: 10px;
    float: left;
    clear: right;
    cursor: pointer;
}

.lineWrapper {
    width: 100%;
    height: auto;
    float: left;
    clear: right;
}

.textbox {
    width: 100%;
    height: auto;
    border-style: none;
    font-family: 'cocomatpro-regular';
    font-size: .85em;
    color: black;
    border-bottom-color: #00a89d;
    border-bottom-style: solid;
    border-bottom-width: 2px;
    margin-bottom: 10px;
}

.textview {
    width: 100%;
    min-height: 300px;
    max-height: 500px;
    border-style: none;
    font-family: 'cocomatpro-regular';
    font-size: .85em;
    color: black;
    border-bottom-color: #00a89d;
    border-bottom-style: solid;
    border-bottom-width: 2px;
    margin-bottom: 10px;
}
</style>